import { TextField } from '@cmsgov/ds-medicare-gov';
import { useState } from 'react';
import translate from '../functions/translate';
import Button from './button';
import MedicareNumberDialog from './MedicareNumberDialog';

interface MedicareNumberSectionProps {
    onChange: (value: string, doImmediateValidation?: boolean) => void
    value: string
    errorMessage: string | null
    parentComponentHeading: string
    onBlur: (value: string, doImmediateValidation?: boolean) => void
    inputRef?: ((ref: HTMLInputElement) => void)
    testId?: string
    onClick?: () => void
    onFocus?: () => void
    noHint?: boolean
    labelClassName?: string
}

const MedicareNumberSection = (props: MedicareNumberSectionProps) => {
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const [maskedMbi, updateMaskedMbi] = useState<string>('');

    function maskMbi(value: string) {
        const mbi = value.trim().match(/^(.{4})(.{3})(.{4})$/);
        if (!mbi) {
            updateMaskedMbi('');
            return;
        }
        const mbiMask = mbi[1] + '-' + mbi[2] + '-' + mbi[3];
        updateMaskedMbi(mbiMask);
    }

    const closeDialog = () => setDialogIsOpen(false);

    const openDialogButton = <Button
        analyticsData={{
            text: translate('where_can_i_find_mbi'),
            linkUrl: translate('where_can_i_find_mbi'),
            parentComponentHeading: props.parentComponentHeading
        }}
        variation="ghost"
        onClick={() => setDialogIsOpen(true)}
        style={{
            padding: 0,
            textAlign: 'left',
        }}
    >
        {translate('where_can_i_find_mbi')}
    </Button>

    return <>
        <TextField
            data-testid={props.testId}
            errorMessage={props.errorMessage}
            hint={!props.noHint && openDialogButton}
            inputRef={props.inputRef}
            label={translate('medicare_number')}
            labelClassName={props.labelClassName}
            name={'medicareNumber'}
            onBlur={(event) => {
                maskMbi(event.target.value);
                props.onBlur(event.currentTarget.value, true);
            }}
            onChange={(event) => { props.onChange(event.currentTarget.value) }}
            onClick={props.onClick}
            onFocus={() => {
                updateMaskedMbi('');
                props.onFocus && props.onFocus();
            }}
            value={maskedMbi || props.value}
            size="medium"
        />
        <MedicareNumberDialog isOpen={dialogIsOpen} onExit={closeDialog}/>
    </>;
}

export default MedicareNumberSection;
